import React from "react";
import styled from "styled-components";
import { AppContext } from "contexts/app";

const EleDiv = styled.div`
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.isDark ? "#fff" : "#333")};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export default function Foot() {
  const [state, dispatch] = React.useContext(AppContext);
  const { isDark } = state;

  return (
    <EleDiv
      isDark={isDark}
    >{`© ${new Date().getFullYear()} FLOXYPAY.COM. All Rights Reserved.`}</EleDiv>
  );
}
